import { jsx as _jsx } from "react/jsx-runtime";
import { memo, useContext, useMemo } from 'react';
import { DeviceConfig } from '../device/config/types';
import { HeatingDeviceConfigProvider } from './config';
import { LegacyHeatingDeviceConfigProvider } from './legacy';
import { Z3KHeatingDeviceConfigProvider } from './z3k';
/**
 * @function
 * Контекст для вкладки отопления
 * @param children - вкладка отопления
 * @param custom_content - кастомные объекты для карточек
 */
export const HeatingDeviceContentProvider = memo(function HeatingDeviceContentProvider(props) {
    const { children, custom_content, templates, support_ui_settings = true } = props;
    const { is_legacy_device } = useContext(DeviceConfig);
    const heating_device_provider = useMemo(() => {
        if (is_legacy_device) {
            return (_jsx(LegacyHeatingDeviceConfigProvider, { templates: templates, support_ui_settings: support_ui_settings, children: children }));
        }
        return (_jsx(Z3KHeatingDeviceConfigProvider, { custom_config_ids: custom_content, templates: templates, support_ui_settings: support_ui_settings, children: children }));
    }, [children, custom_content, is_legacy_device, support_ui_settings]);
    return (_jsx(HeatingDeviceConfigProvider, { children: heating_device_provider }));
});
